<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<template>
    <section id="hero"
      class="pt-32 pb-24 md:pt-48 md:pb-32 lg:pt-64 lg:pb-48 bg-cover bg-center bg-no-repeat relative flex items-center"
      :style="{
        backgroundImage: `url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=2560&q=80')`
      }"

    >
      <div class="absolute inset-0 bg-black/50"></div>
      <div class="container mx-auto px-6 md:px-12 lg:px-16 xl:px-24 relative text-center max-w-5xl">
        <h1 class="text-5xl md:text-6xl lg:text-7xl font-extrabold leading-tight mb-6 text-white drop-shadow-lg">
          {{ t('heroSection.title') }}
        </h1>
        <p class="text-xl md:text-2xl text-gray-100 leading-relaxed">
          {{ t('heroSection.subtitle') }}
        </p>
      </div>
    </section>
</template>
